import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";
import { ClerkProvider, useAuth } from "@clerk/clerk-react";
import { App } from "./App";
import { queryClient } from "./api/queryClient";
import { registerTokenGetter } from "./lib/auth";
import { TenantProvider } from "./context/TenantContext";
import "./styles/globals.css";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
if (!publishableKey) {
  throw new Error(
    "VITE_CLERK_PUBLISHABLE_KEY is not set. Add it to .env (copy from your Clerk dashboard API Keys page).",
  );
}

/** Registers Clerk's getToken() with the non-React apiFetch helper.
 *  Mounted inside <ClerkProvider> so useAuth() is available. */
function TokenBridge() {
  const { getToken } = useAuth();
  useEffect(() => {
    registerTokenGetter(() => getToken());
  }, [getToken]);
  return null;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={publishableKey} afterSignOutUrl="/login">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <TokenBridge />
          <TenantProvider>
            <App />
          </TenantProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ClerkProvider>
  </React.StrictMode>,
);
